import data from "../../../../../src/Timeline/Timeline.docs.json";
import * as React from 'react';
export default {
  data,
  React
};